import { existsSync } from "fs";
import path from "path";

export function resolveSource(filepath: string) {
  const jsPath = path.resolve(filepath + ".js");
  if (!process.env.SHOULD_USE_TSNODE) {
    return jsPath;
  }

  const tsPath = path.resolve(filepath + ".ts");
  if (existsSync(tsPath)) {
    return tsPath;
  }
  if (existsSync(jsPath)) {
    return jsPath;
  }
  throw new Error(
    `${filepath} does not exist with extension .ts or .js.\n  Tried:\n - ${tsPath}\n - ${jsPath}`
  );
}
